import React from 'react'
import { observer } from 'mobx-react'

import Dialog from 'components/dialog/Dialog'
import Button from 'components/button/Button'
import Read from 'assets/illustrations/read.svg'

import styles from './readonlyDialog.scss'

interface IProps {
  onClose: () => void
}

class ReadonlyDialog extends React.PureComponent<IProps> {
  render() {
    const { onClose } = this.props

    return (
      <Dialog className={styles.dialog} onClose={onClose}>
        <div className={styles.container}>
          <Read className={styles.illustration} />

          <div className={styles.title}>Read-only zone</div>
          <div className={styles.content}>
            Pending changes could not be saved because you do not have write
            permissions for this database
          </div>

          <Button green className={styles.confirmButton} onClick={onClose}>
            Understood
          </Button>
        </div>
      </Dialog>
    )
  }
}

export default observer(ReadonlyDialog)
